import { z } from 'zod';
import { LogoSchema, imageSchema } from './image-schema';
import { locationSchema } from './location-schema';
import { metaSchema } from './meta-schema';
import { pageConfigurationSchema } from './page-configuration-schema';
import { personSchema } from './person-schema';
import { productSchema } from './product-schema';
import { subscriptionLevel } from './subscription-level';
import { trustFactorSchema } from './trust-factor-schema';

export type TOffice = z.infer<typeof officeSchema>;

export const officeSchema = z.object({
  id: z.number(),
  attributes: z.object({
    name: z.string(),
    showReviewInReceipt: z.boolean(),
    leadboxCustomerId: z.string().optional().nullable(),
    placeId: z.string().optional().nullable(),
    address: z.string().optional().nullable(),
    postarea: z.string().optional().nullable(),
    subscriptionLevel: subscriptionLevel,
    postcode: z.string().optional().nullable(),
    email: z.string().optional().nullable(),
    phone: z.string().optional().nullable(),
    website: z.string().optional().nullable(),
    people: z.object({
      data: z.array(personSchema),
    }),
    products: z.object({
      data: z.array(productSchema),
    }),
    trust_factors: z.object({
      data: z.array(trustFactorSchema),
    }),
    icon: imageSchema,
    article: z.string().optional().nullable(),
    topImage: imageSchema,
    location: locationSchema,
    configuration: pageConfigurationSchema,
    logo: LogoSchema,
    background: imageSchema,
    meta: metaSchema,
  }),
});
